import { Session } from '@supabase/supabase-js';
import { useEffect, useState } from 'react';
import { supabase } from '../supabase-client';

export default function useAuth() {
  const [userData, setUserData] = useState<Session | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setUserData(data.session);
    });
  }, []);

  return userData;
}
